
import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileOptimizedLayout } from './MobileOptimizedLayout';
import { useToast } from '@/hooks/use-toast';
import { useIsMobile } from '@/hooks/use-mobile';
import { SearchProvider } from '@/components/search/SearchProvider';
import { CommandPalette } from '@/components/search/CommandPalette';
import { useLanguage } from '@/i18n/context/LanguageContext';
import { tr } from '@/i18n/utils/tr';
import { dashboardTranslations } from '@/i18n/locales/components/dashboard';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { toast } = useToast();
  const isMobile = useIsMobile();
  
  // Безопасная обработка useLanguage - если контекст недоступен, используем fallback
  let language: 'ru' | 'en' = 'ru';
  try {
    const langContext = useLanguage();
    language = langContext.language;
  } catch (error) {
    console.warn('LanguageContext не доступен в DashboardLayout, используем fallback "ru"');
  }

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
    if (!isMobile) {
      toast({
        title: sidebarCollapsed 
          ? tr(dashboardTranslations.ru.layout.sidebarExpanded, dashboardTranslations.en.layout.sidebarExpanded, language)
          : tr(dashboardTranslations.ru.layout.sidebarCollapsed, dashboardTranslations.en.layout.sidebarCollapsed, language),
        duration: 1500,
      });
    }
  };

  return (
    <SearchProvider>
      <CommandPalette />
      <MobileOptimizedLayout
        sidebar={<Sidebar collapsed={sidebarCollapsed} />}
        topBar={<TopBar onToggleSidebar={toggleSidebar} sidebarCollapsed={sidebarCollapsed} />}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      >
        <div className="animate-fade-in">
          {children}
        </div>
      </MobileOptimizedLayout>
    </SearchProvider>
  );
};
